const WooCommerceRestApi = require("@woocommerce/woocommerce-rest-api").default;
const isLocalhost = require('../../helpers').isLocalhost();
const isDevelopment = require('../../helpers').isDevelopment();

const config = isLocalhost ? require('./wc.dev.config').config : isDevelopment ? require('./wc.dev.config').config : require('./wc.prod.config').config;

const api = new WooCommerceRestApi({
  url: config.url,
  consumerKey: config.consumerKey,
  consumerSecret: config.consumerSecret,
  version: "wc/v3"
});

module.exports = { 
  api
}
